export const DEFAULT_AVATAR_SIZE = 40;
/**
 * The picture of a player who has not set one: the mascot's face.
 *
 * It was a stock portrait of a stranger, the same stranger on every account.
 * A player with no picture of their own now wears the brand's, in the header,
 * the chat, the referral list and the tables of the original games alike.
 */
export const DEFAULT_AVATAR_SRC = "/assets/images/mascot-head.webp";
